import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'
export function useActiveViewId (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('activeViewIdChanged', callback),
    () => state.activeViewId
  )
}
